import { Injectable } from "@angular/core";
import { MdDialog, MdDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { AppLoaderComponent } from "./app-loader.component";

interface Config {
  width?: string;
}

@Injectable()
export class AppLoaderService {
  dialogRef: MdDialogRef<AppLoaderComponent>;
  public isLoginDialogOpen: boolean = false;
  constructor(private dialog: MdDialog) {}

  public open(
    title: string = "Please wait",
    percentage:string="",
    _config: Config = { width: "200px" }
  ): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, {
      disableClose: true        
    });
    
    this.dialogRef.componentInstance.title = title;
    this.dialogRef.componentInstance.percentage = percentage;
    this.isLoginDialogOpen = true;
    return this.dialogRef.afterClosed();
  }

  public close() {
    if (this.dialogRef) this.dialogRef.close();
    this.isLoginDialogOpen = false;
  }

  public IsLoader(): boolean {
    return this.isLoginDialogOpen;
  }

  public ChangeLoaderTitle(input){
    this.dialogRef.componentInstance.title = input;
  }

  public ChangePercentage(input){
    this.dialogRef.componentInstance.percentage = input;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/app-loader/app-loader.service.ts